module.exports = __webpack_public_path__ + "static/img/goodness6.339ac7ef.png";